export default {
  data: function data() {
    return {
      dragStartIndex: null,
      // 被拖动的
      dragging: null // 在当前哪个元素上面
    };
  },
  methods: {
    dragstart: function dragstart(e, index) {
      this.dragStartIndex = index;
    },
    dragover: function dragover(e) {
      e.preventDefault();
    },
    dragenter: function dragenter() {},
    dragend: function dragend() {
      this.dragging = null;
      this.dragStartIndex = null;
    }
  }
};